export enum ConsumptionDataType {
   NO_DATA = "NO_DATA",
   ESTIMATED = "ESTIMATED",
   PARTLY = "PARTLY",
   FULL = "FULL"
}